const DEFAULT_CHAPTERS_CONFIG = {
    "enable": true,
    "ui-configs": {
        "always-visible": {
            "enable": true,
            "auto-open": {
                "enable": true,
                "timer": 4000,
                "auto-hide": {
                    "enable": true,
                    "timer": 4000
                }
            }
        },
        "menu": {
            "hide-on-chapter-click": true,
            "heading": {
                "enable": true,
                "html-content": "In This Video"
            },
            "hide-icon": {
                "use-default": true,
                "html-content": "HIDE"
            }
        },
        "markers": {
            "enable": false
        }
    },
    "items": [] // chapterProps
}

// const defaultChapterProps = {
//     "chapterName": "", // "Chapter 1"
//     "startTime": "", // "00:00"
//     "endTime": "" // "01:00"
// }

export { DEFAULT_CHAPTERS_CONFIG }